import React from 'react';
import { SimpleChip } from './SimpleChip';
import { ChipSize, ChipVariant } from './types';

interface StatusChipProps {
     hasDraftChanges?: boolean;
     hasUnsavedChanges?: boolean;
     workflowTasksCount?: number;
     allTasksReleased?: boolean;
     size?: ChipSize;
     variant?: ChipVariant;
     sx?: any;
}

// Constants
const CHIP_LABELS = {
     SYNC_IN_PROGRESS: 'sync is in progress',
     DRAFT_WAITING: 'saved record(s) waiting to be submitted',
     UNSAVED_CHANGES: 'unsaved changes',
     RELEASED: 'applicable',
     NO_CHANGES: 'no changes',
} as const;

export const StatusChip: React.FC<StatusChipProps> = ({ 
     hasDraftChanges, 
     hasUnsavedChanges, 
     workflowTasksCount, 
     allTasksReleased, 
     size = 'small', 
     variant = 'filled', 
     sx 
}) => {
     // Priority 1: Show sync in progress
     if (workflowTasksCount && workflowTasksCount > 0) {
          return <SimpleChip label={CHIP_LABELS.SYNC_IN_PROGRESS} color="warning" size={size} variant={variant} sx={sx} />;
     }

     // Priority 2: Show draft changes
     if (hasDraftChanges) {
          return <SimpleChip label={CHIP_LABELS.DRAFT_WAITING} color="warning" size={size} variant={variant} sx={sx} />;
     }

     // Priority 3: Show unsaved changes
     if (hasUnsavedChanges) {
          return <SimpleChip label={CHIP_LABELS.UNSAVED_CHANGES} color="info" size={size} variant={variant} sx={sx} />;
     }

     // Priority 4: Show released status when all tasks are released and no workflow
     if (allTasksReleased && workflowTasksCount === 0) {
          return <SimpleChip label={CHIP_LABELS.RELEASED} color="success" size={size} variant={variant} sx={sx} />;
     }

     // Priority 5: Show no changes when there are no changes and not all tasks are released
     if (!allTasksReleased) {
          return <SimpleChip label={CHIP_LABELS.NO_CHANGES} color="default" size={size} variant="outlined" sx={sx} />;
     }

     return null;
};